// extracted by mini-css-extract-plugin
export default {"form":"Info_form__wOjwv","total":"Info_total__j3Td9","overall":"Info_overall__VGw2D","buttons":"Info_buttons__6a3lu","links":"Info_links__Jewna"};